import * as Yup from "yup";

export function initialValuesThree(user, formData = {}) {
  const userData = { ...formData, ...user };

  return {
    contactPersons: [
      {
        name: user?.firstname + " " + user?.lastname || "",
        phone: userData?.phonePerson || "",
        email: user?.email || "",
      },
    ],
  };
}

export function validationSchemaTrhee(t) {
  return Yup.object({
    // Valida el objeto de dirección de factura
    contactPersons: Yup.array().of(
      Yup.object({
        name: Yup.string().required(
          t("partners:validation.contactNameRequired"),
        ),
        phone: Yup.string()
          .notRequired() // o .nullable()
          .matches(/^\+?\d+$/, t("partners:validation.contactPhoneFormat")),
        email: Yup.string()
          .email(t("partners:validation.contactEmailInvalid"))
          .required(t("partners:validation.contactEmailRequired")),
      }),
    ),
  });
}
